module.exports = __webpack_public_path__ + "static/pd-logo-f34f6d23756dd3d5390a058e45b95c1b.png";